import { render } from "./GridColumn.vue?vue&type=template&id=24d3f7f4&ts=true"
import script from "./GridColumn.vue?vue&type=script&lang=ts"
export * from "./GridColumn.vue?vue&type=script&lang=ts"

import "./GridColumn.vue?vue&type=style&index=0&id=24d3f7f4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__